<script>
import CommonTableComponent from "@/components/table.vue";
import datetime from "@/mixins/datetime";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";
import sweetAlert from "@/mixins/sweetAlert";
import DatePicker from "vue2-datepicker";

export default {
  mixins: [datetime,tableSearch,sweetAlert],
  data() {
    return {
      busyGetData: false,
      ids: [],
      data: [],
      targetDate: this.getToday(),
      visible: false,
      filters: {
        column: this.$route.query.column || "estimates.estimate_cd",
        dir: this.$route.query.dir || "DESC",
      },
      btnDeleteText: this.$lang.button.delete
    }
  },
  components: {
    CommonTableComponent,DatePicker
  },
  methods: {
    openModal(ids) {
      this.ids = ids;
      this.getData();
      this.$bvModal.show('modal-confirm-submit')
    },
    async getData() {
      this.busyGetData = true;
      const idsString = this.ids.join(',');
      const response = await this.$http.get(apiEndpoints.estimates_confirm + `?ids=${idsString}`);
      const { status, data } = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
      }
    },
    closeModal() {
      this.$bvModal.hide('modal-confirm-submit')
    },
    onHiddenModal() {
      this.$emit('modalHidden')
    },
    async submit() {
      const {data, status} = await this.$http.post(apiEndpoints.estimates_export, {ids: this.idsExport, target_date: this.targetDate});
      if (status) {
        this.$emit('dataSubmitted')
        this.closeModal()

        return this.successToast("見積明細を送信しました", false, 3000);
      }

      return this.errorToast(data.message, false, 3000);
    },
    removeItem(row) {
      this.data = this.data.filter(item => item.id !== row.id)
    },
  },
  computed: {
    headers() {
      return [
        ...this.$constant.tableHeaders.estimates.index,
        {
          text: '',
          value: '',
          sortable: false,
        }
      ];
    },
    idsExport() {
      return this.data.map(item => item.id);
    },
    isUniqueCustomer() {
      const customerNames = this.data.map(item => item.customer_name);
      const customerNamesUnique = [...new Set(customerNames)];

      // 送信する全ての見積明細が同一の得意先略称であること
      return customerNamesUnique.length === 1;
    }
  },
}
</script>
<template>
  <div>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      id="modal-confirm-submit"
      centered
      title-class="font-18"
      hide-footer
      hide-header
      scrollable
      @hidden="onHiddenModal"
    >
      <b-row>
        <div>
          <p>選択された項目を送信してもよろしいですか？</p>
        </div>
      </b-row>
      <b-row class="mt-2">
        <CommonTableComponent :height-class="`table-wrapper-500`" class="text-small">
          <thead class="table-light">
          <tr>
            <th
              v-for="(item, index) in headers"
              :key="index"
              class="text-center"
            >
              <span v-if="item.sortable">
                        <span v-html="item.text"></span>
                      </span>
              <span v-else v-html="item.text"> </span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(item, index) in data"
            :key="index"
          >
            <td>
              {{ item.id }}
            </td>
            <td>
              {{ item.estimate_cd }}
            </td>
            <td>
              {{ item.case_name }}
            </td>
            <td>
              {{ item.waste_work_name }}
            </td>
            <td>
              {{ item.customer_name }}
            </td>
            <td>
              {{ item.discharger_name }}
            </td>
            <td>
              {{ item.discharger_site_name }}
            </td>
            <td>
              {{ item.invoice_product_name }}
            </td>
            <td>
              {{ item.unit_name }}
            </td>
            <td class="text-end col-price">
              <div v-if="item.unit_price">{{ item.unit_price | number}}</div>
              <div v-if="item.unit_price_2">{{ item.unit_price_2 | number}}</div>
              <div v-if="item.unit_price_3">{{ item.unit_price_3 | number}}</div>
            </td>
            <td class="text-end col-price">
              <div v-if="item.unit_cost">{{ item.unit_cost | number}}</div>
              <div v-if="item.unit_cost_2">{{ item.unit_cost_2 | number}}</div>
              <div v-if="item.unit_cost_3">{{ item.unit_cost_3 | number}}</div>
            </td>
            <td class="col-end-date">
              <div v-if="item.end_date_of_application">{{ item.end_date_of_application}}</div>
              <div v-if="item.end_date_of_application_2">{{ item.end_date_of_application_2}}</div>
              <div v-if="item.end_date_of_application_3">{{ item.end_date_of_application_3}}</div>
            </td>
            <td>
              <b-button
                @click="removeItem(item)"
                class="text-nowrap btn-custom-red"
              >
                <i class="fas fa-eraser"></i> {{ btnDeleteText }}
              </b-button>
            </td>
          </tr>
          </tbody>
        </CommonTableComponent>
      </b-row>
      <div class="my-4">
        <span class="target-date-label">単価適用日</span>
        <date-picker
                lang="ja"
                v-model="targetDate"
                :clearable="false"
                placeholder="YYYY-MM-DD"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                position="left"
                type="date"
                class="target-date"
        ></date-picker>
      </div>
      <b-row>
        <b-overlay
          :show="busyGetData"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div class="d-flex justify-content-center align-items-center gap-2 mt-2">
            <b-button
              variant="primary"
              size="lg"
              @click="submit"
              :disabled="!isUniqueCustomer"
            >
              <i class="fas fa-check"></i> {{ this.$lang.button.ok }}
            </b-button>
            <b-button
              variant="danger"
              size="lg"
              @click="closeModal"
            >
              <i class="fas fa-times"></i> {{ this.$lang.button.cancel }}
            </b-button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>
<style scoped>
.text-small {
  font-size: 12px;
}
.col-price {
  min-width: 80px;
  white-space: pre-line !important;
}
.col-end-date {
  min-width: 111px;
  white-space: pre-line !important;
}
.target-date-label {
  width: 40px !important;
  display: inline !important;
  margin-right: 1em;
}
.target-date {
  width: 140px !important;
  display: inline-block !important;
}
</style>